/**
 * LangSmith constants and URL helpers.
 * Single source of truth for both frontend and backend.
 */
const LANGSMITH_ORG = "96d28df1-2fc5-4dfe-b4b2-2b1e61ac6254";
const LANGSMITH_PROJECT_IDS = {
    PRODUCTION: "b5a5c84b-86e7-4291-82d0-6cc1e7dbb3df",
    DEV: "12f58ac9-374c-4c08-96c1-df9e454ea704",
};
/**
 * Generates a URL to view a LangSmith trace in the production project.
 * @param runId - The LangSmith run ID
 * @returns The URL to view the trace
 */
export function langsmithTraceUrl(runId) {
    return `https://smith.langchain.com/o/${LANGSMITH_ORG}/projects/p/${LANGSMITH_PROJECT_IDS.PRODUCTION}?peek=${runId}&peeked_trace=${runId}`;
}
/**
 * Generates a URL to view a LangSmith trace in the development project.
 * @param runId - The LangSmith run ID
 * @returns The URL to view the trace
 */
export function langsmithDevTraceUrl(runId) {
    return `https://smith.langchain.com/o/${LANGSMITH_ORG}/projects/p/${LANGSMITH_PROJECT_IDS.DEV}?peek=${runId}&peeked_trace=${runId}`;
}
//# sourceMappingURL=langsmith.js.map